import { render, staticRenderFns } from "./CheckoffAdviceDetails.vue?vue&type=template&id=7142f237"
import script from "./CheckoffAdviceDetails.vue?vue&type=script&lang=js"
export * from "./CheckoffAdviceDetails.vue?vue&type=script&lang=js"
import style0 from "./CheckoffAdviceDetails.vue?vue&type=style&index=0&id=7142f237&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports